import image1 from "../../../assets/images/weeding/IMG_2001.JPG"
import image2 from "../../../assets/images/weeding/IMG_2002.JPG"
import image3 from "../../../assets/images/weeding/IMG_2003.JPG"
import image4 from "../../../assets/images/weeding/IMG_2004.JPG"
import image5 from "../../../assets/images/weeding/IMG_2005.JPG"
import image6 from "../../../assets/images/weeding/IMG_2006.JPG"
import image7 from "../../../assets/images/weeding/IMG_2007.JPG"





export const weedingImages = [
    image1,
    image2,
    image3,
    image4,
    image5,
    image6,
    image7,
]

